import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/instantnanobiosensors.webp';
import screenshot_target from '../../../images/letterfunnel/tonychung.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Tony Chung"
      firstname="Tony"
      companyname="Instant NanoBiosensors"
      competition="Sartorius en Quanterix"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/tonychung.js